module.exports = __webpack_public_path__ + "img/wechat-group.0b77e216.jpg";